export default "__VITE_ASSET__602d0a75__"